import { Divider, makeStyles, mergeClasses } from "@fluentui/react-components";
import {
  AirportFlights,
  AirportKpiErrors,
  AirportNotifications,
  AirportOtp,
} from "../../models/airports/AirportConfig";
import AirportFlightsCard from "./AirportFlightsCard";
import AirportNotificationsCard from "./AirportNotificationsCard";
import AirportOTPCard from "./AirportOTPCard";

interface IAirportCardDetailsProps {
  otpData: AirportOtp;
  flightData: AirportFlights;
  notificationData: AirportNotifications;
  kpiErrors?: AirportKpiErrors;
  isMapView: boolean;
}

const AirportCardDetails: React.FunctionComponent<IAirportCardDetailsProps> = (
  props
) => {
  const { isMapView } = props;
  const classes = useStyles();
  const kpiErrors = props.kpiErrors || {
    otp: false,
    flights: false,
    notifications: false,
  };

  const dividerClass = isMapView ? classes.mapViewDivider : "px-2";
  const containerMapViewClass = mergeClasses(
    classes.container,
    classes.containerMapView,
    classes.mapViewCard
  );
  return (
    <div className="w-100 d-flex" data-testid="airport-card-details">
      <AirportOTPCard
        className={
          isMapView
            ? containerMapViewClass
            : mergeClasses(classes.container, classes.otpContainer)
        }
        otpData={props.otpData}
        isError={kpiErrors.otp}
        isMapView={isMapView}
      />

      <Divider vertical className={dividerClass} />

      <AirportFlightsCard
        className={
          isMapView
            ? containerMapViewClass
            : mergeClasses(classes.container, classes.flightsContainer)
        }
        flightData={props.flightData}
        isError={kpiErrors.flights}
        isMapView={isMapView}
      />

      <Divider vertical className={dividerClass} />

      <AirportNotificationsCard
        className={
          isMapView
            ? containerMapViewClass
            : mergeClasses(classes.container, classes.notificationContainer)
        }
        notificationData={props.notificationData}
        isError={kpiErrors.notifications}
        isMapView={isMapView}
      />
    </div>
  );
};

export default AirportCardDetails;

const useStyles = makeStyles({
  container: {
    minWidth: 0,
    boxSizing: "border-box",
  },
  otpContainer: {
    width: "35%",
  },
  flightsContainer: {
    width: "35%",
  },
  notificationContainer: {
    width: "26%",
  },
  containerMapView: {
    width: "32%",
  },
  mapViewCard: {
    padding: "4px 8px",
  },
  mapViewDivider: {
    flexGrow: 0,
  },
});
